import { createSelector } from 'reselect'

import { selectContactsState } from './selectContactsState'

export const selectContacts = createSelector([selectContactsState], (state) => state.data)
